import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import BackToHome from "./BackToHome";

function UsesByGRohit() {
const URL =
"https://gist.githubusercontent.com/g-rohit/27717c7564b368849ccb1e2f572f0d1e/raw/6f74eb39054a0aac2f6c7e141dd7046a35bc3068/uses--by-grohit.json";

const [data, setData] = useState([]);

const [loading, setLoading] = useState(true);

const getUsesData = () => {
fetch(URL)
.then((response) => response.json())
.then((jsonData) => {
setData(jsonData);
setLoading(false);
// console.log(jsonData);
})
.catch((error) => {
console.error("error in fetching data: ", error);
});
};

useEffect(() => {
getUsesData();
}, []);

return (
<>
  <Navbar />
  <div className="container-fluid p-4" id="usesByGRohit">
    <h1 className="text-center text-purple">Uses By G Rohit</h1>
    <p className="text-center">
      My daily uses, to suggest me your fav tools/apps,{" "}
      <a href="mailto:c4cgm78nz@relay.firefox.com" className="external-link on-uses-page">
        drop a mail
      </a>
    </p>

    <div className="row">
      <div className="col table-responsive">
        {data && (
        <table className="table table-bordered">
          <thead className="align-top">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Application name</th>
              <th>URL</th>
              <th>tags</th>
            </tr>
          </thead>
          <tbody>
            {data.map((eachRow, index) => (
            <tr>
              <td key={index + 1}>{index + 1}</td>
              <td>{eachRow.Name}</td>
              <td>{eachRow.ApplicationName}</td>
              <td><a href={eachRow.URL} target="_blank" rel="noopener noreferrer" className="link-light">{eachRow.URL}</a></td>
              <td>{eachRow.tags}</td>
            </tr>
            ))}
          </tbody>
        </table>
        )}
      </div>
    </div>
  </div>
        <BackToHome/>

</>
);
}

export default UsesByGRohit;
